/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import Form from 'forms/_.extend';
import Loading from 'components/Loading/Loading';
import ActionDrawerHeader from 'views/ActionDrawer/components/ActionDrawerHeader/ActionDrawerHeader';

import ArchiveOwnedAssetForm from './ArchiveOwnedAssetForm/ArchiveOwnedAssetForm';
import ArchiveOwnedAssetSuccess from './ArchiveOwnedAssetSuccess/ArchiveOwnedAssetSuccess';
import ArchiveOwnedAssetError from './ArchiveOwnedAssetError/ArchiveOwnedAssetError';

import styles from '../../../ActionDrawer.module.scss';

type TypeProps = {|
  formData: Object,
  actionDrawerStore: TypeActionDrawerStore,
  asset: Object,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class ArchiveOwnedAsset extends React.Component<*> {
  createForm = () => {
    const { t, actionDrawerStore }: TypeProps = this.props;

    const asset: Object = this.props.formData;

    const fields: Array<Object> = [
      {
        name: 'archiveReason',
        label: t('general:assets.reasons.why_archive'),
        fields: [
          {
            name: 'reason',
            label: t('general:reasons.reason_for_archiving'),
            rules: 'required|string',
            value: '',
            extra: {
              options: [
                {
                  id: '1',
                  label: t('general:reasons.options.asset_disposed_of'),
                },
                {
                  id: '2',
                  label: t('general:reasons.options.asset_scrapped'),
                },
                {
                  id: '3',
                  label: t('general:reasons.options.asset_beyond_repair'),
                },
                {
                  id: '4',
                  label: t('general:reasons.options.asset_lost'),
                },
                {
                  id: 'other',
                  label: t('general:reasons.options.other'),
                },
              ],
            },
          },
        ],
      },
    ];

    const hooks: Object = {
      onSuccess(data: Object) {
        const { reason }: Object = data.values().archiveReason;

        actionDrawerStore.archiveAsset(asset.id, {
          activity_reason: reason,
        });
      },
    };

    return new Form(
      { fields },
      {
        hooks,
        name: 'archiveOwnedAsset',
      }
    );
  };

  render(): React.Element<*> {
    const { t, actionDrawerStore }: TypeProps = this.props;

    const asset: Object = this.props.formData;

    const title: string = t('general:actions.archive_owned_asset');

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    if (actionDrawerStore.error) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.error}`}>
          <ActionDrawerHeader title={title} />
          <ArchiveOwnedAssetError asset={asset} />
        </div>
      );
    }

    if (actionDrawerStore.success) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.success}`}>
          <ActionDrawerHeader title={title} />
          <ArchiveOwnedAssetSuccess response={actionDrawerStore.response} />
        </div>
      );
    }

    return (
      <div className={styles['action-drawer-form']}>
        <ActionDrawerHeader title={title} />
        <ArchiveOwnedAssetForm asset={asset} form={this.createForm()} />
      </div>
    );
  }
}
